import {CalendarBar, Tab} from "omoplay";
import moment from "moment";
import {useEffect, useState} from "react";


const ProjectCalendarSearchBar = ({periodStartDate, initDateType, onConfirm}) => {
    const dateItems = [
        { value: "all", label: "전체", selected: initDateType === "all" },
        { value: "month", label: "최근 한 달", selected: initDateType === "month" },
        { value: "week", label: "최근 일주일", selected: !initDateType || initDateType === "week" },
    ]

    const [dateRange, setDateRange] = useState(undefined);

    useEffect(() => {
        let convertDateRage = dateRange
        if (initDateType === "all") {
            convertDateRage = periodStartDate ? moment(periodStartDate) : undefined
        } else if (initDateType === "month") {
            convertDateRage = {
                startDate: moment().subtract(1, "month").toDate(),
                endDate: moment().toDate(),
            }
        } else if (initDateType === "week") {
            convertDateRage = {
                startDate: moment().subtract(6, "days").toDate(),
                endDate: moment().toDate(),
            }
        }
        setDateRange(convertDateRage)
    }, [initDateType]);

    const handleQuickChange = (type) => {
        let convertDateRage = dateRange

        if (type === "all") {
            convertDateRage = undefined
        } else if (type === "month") {
            convertDateRage = {
                startDate: moment().subtract(1, "month").toDate(),
                endDate: moment().toDate(),
            }
        } else if (type === "week") {
            convertDateRage = {
                startDate: moment().subtract(6, "days").toDate(),
                endDate: moment().toDate(),
            }
        }
        setDateRange(convertDateRage)
        onConfirm(
            convertDateRage === undefined ? undefined : {
                startDate: moment(convertDateRage?.startDate).format("yyyy-MM-DD"),
                endDate: moment(convertDateRage?.endDate).format("yyyy-MM-DD")
            }
        )
    }

    return (
        <div className="flex gap-4 omp-calendar-right">
            <Tab
                variants="input"
                items={dateItems}
                onChanged={(data) => handleQuickChange(data.value)}
            />
            <CalendarBar initDate={dateRange}
                         key={dateRange}
                         onConfirm={(dateProps) => {
                             setDateRange({
                                 startDate: moment(dateProps.startDate).toDate(),
                                 endDate: moment(dateProps.endDate).toDate()
                             })
                             onConfirm({
                                 startDate: moment(dateProps.startDate).format("yyyy-MM-DD"),
                                 endDate: moment(dateProps.endDate).format("yyyy-MM-DD")
                             })
                         }} />
        </div>
    )
}

export default ProjectCalendarSearchBar